import React from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import Text from '@pezeshk-book/ui-kit/text';
import Button from '@pezeshk-book/ui-kit/button';
import Image from '@elements/image';
import ShareIcon from '@icons-components/share-icon';
import { ShareBoxProps } from '@modules/share-box/share-box.props';

const ShareBox = ({ title, link, translate }: ShareBoxProps) => {
  return (
    <Div className={`gap-1 items-center`}>
      <Div className={'relative w-4 h-4 text-grey-500'}>
        <ShareIcon/>
      </Div>
      <Text color={'grey.500'} typography={'sm'} className={'whitespace-nowrap'}>{translate}</Text>
      <Div>
        <Button
          href={`https://telegram.me/share/url?url=${link}&text=${title}`}
          className={'!pl-0 !pr-0'}
          shape={'square'}
          variant={'text'}
          size="tiny"
          startAdornmentClassName={'!w-5 !h-5 !max-w-5 !max-h-5'}
          startAdornment={<Image alt={'icon'} src={'/images/telegram.png'} fill={true}/>}
        />
        <Button
          href={`https://web.whatsapp.com/send?text=${link}`}
          className={'!pl-0 !pr-0'}
          shape={'square'}
          variant={'text'}
          size="tiny"
          startAdornmentClassName={'!w-5 !h-5 !max-w-5 !max-h-5'}
          startAdornment={<Image alt={'icon'} src={'/images/whatsapp.png'} fill={true}/>}
        />
        <Button
          href={`https://twitter.com/share?url=${link}&text=${title}`}
          className={'!pl-0 !pr-0'}
          shape={'square'}
          variant={'text'}
          size="tiny"
          startAdornmentClassName={'!w-5 !h-5 !max-w-5 !max-h-5'}
          startAdornment={<Image alt={'icon'} src={'/images/twitter.png'} fill={true}/>}
        />
        <Button
          href={`https://www.facebook.com/sharer/sharer.php?u=${link}`}
          className={'!pl-0 !pr-0'}
          shape={'square'}
          variant={'text'}
          size="tiny"
          startAdornmentClassName={'!w-5 !h-5 !max-w-5 !max-h-5'}
          startAdornment={<Image alt={'icon'} src={'/images/facebook.png'} fill={true}/>}
        />
      </Div>
    </Div>
  );
};

export default ShareBox;
